import React from "react";
import {
    FaFacebook,
    FaGithub,
    FaGitlab,
    FaInstagram,
    FaTwitter,
    FaMedium
} from "react-icons/lib/fa";

	/*
	<li>
	    <a href="https://medium.com/@jon.chin"
	       target="_blank">
		<FaMedium />
	    </a>
	</li>
	*/


const SocialLinks = () => (
    <ul className="social">
	<li>
	    <a href="https://www.facebook.com/teachwritekick"
	       target="_blank">
		<FaFacebook />
	    </a>
	</li>
	<li>
	    <a href="https://twitter.com/teachwritekick"
	       target="_blank">
		<FaTwitter />
	    </a>
	</li>
	<li>
	    <a href="https://www.instagram.com/teachwritekick/"
	       target="_blank">
		<FaInstagram />
	    </a>
	</li>
	<li>
	    <a href="https://github.com/jonathan-chin"
	       target="_blank">
		<FaGithub />
	    </a>
	</li>
	<li>
	    <a href="https://gitlab.com/jon.chin"
	       target="_blank">
		<FaGitlab />
	    </a>
	</li>
    </ul>
);

export default SocialLinks;




// WEBPACK FOOTER //
// ./src/components/SocialLinks.js